"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossibleIncidentSchema = exports.incidentDateString = exports.MAX_INCIDENT_DATE_YEARS = exports.MIN_INCIDENT_DATE_YEARS = void 0;
const zod_1 = require("zod");
const constants_1 = require("../constants");
const numbers_1 = require("../numbers");
const StateCodes_1 = require("../enums/StateCodes");
const dates_1 = require("../dates");
exports.MIN_INCIDENT_DATE_YEARS = 0;
exports.MAX_INCIDENT_DATE_YEARS = 52;
exports.incidentDateString = (0, dates_1.dateInYearsRangeStringSchemaFactory)(exports.MIN_INCIDENT_DATE_YEARS, exports.MAX_INCIDENT_DATE_YEARS, `Incident date should not be more than ${exports.MAX_INCIDENT_DATE_YEARS} years ago, or after today's date.`);
exports.impossibleIncidentSchema = zod_1.z.object({
    id: zod_1.z.string().min(constants_1.MIN_DEFAULT_STRING_LENGTH).max(36).regex(constants_1.REGEX.defaultString).nullable(),
    type: constants_1.defaultNullableString,
    typeDetails: constants_1.defaultNullableString,
    descriptionRaw: constants_1.defaultNullableString,
    date: zod_1.z.nullable(exports.incidentDateString),
    state: zod_1.z.nullable(zod_1.z.nativeEnum(StateCodes_1.StateCodes)),
    paidAmountCents: zod_1.z.nullable(zod_1.z.number().min(0).max((0, numbers_1.billion)(7.5))),
    liabilityMedicalPaidAmountCents: zod_1.z.nullable(zod_1.z.number().min(0).max((0, numbers_1.billion)(7.5))),
}).strict();
